module.exports = __webpack_public_path__ + "static/bankrate-banner-197f574315c9a78cf61008daf205763f.png";